import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SubscriptionStatusDto {
  active: boolean;
  nextBillingDate: string | null;
  telegramLinked: boolean;
  cancelAtPeriodEnd?: boolean;
  plan?: string | null;
  status?: string | null;
}

interface MyPageState {
  subscription: SubscriptionStatusDto;
  loadingSubscription: boolean;
  restartingSubs: Record<string, boolean>;
  removingSubs: Record<string, boolean>;
  error: string | null;
}

const initialState: MyPageState = {
  subscription: {
    active: false,
    nextBillingDate: null,
    telegramLinked: false,
    cancelAtPeriodEnd: false,
  },
  loadingSubscription: false,
  restartingSubs: {},
  removingSubs: {},
  error: null,
};

const myPageSlice = createSlice({
  name: "myPage",
  initialState,
  reducers: {
    fetchSubscriptionStatusRequest: (state, _action: PayloadAction<{ userId: number }>) => {
      state.loadingSubscription = true;
      state.error = null;
    },
    fetchSubscriptionStatusSuccess(state, action: PayloadAction<SubscriptionStatusDto>) {
      console.log("[myPageSlice] fetchSubscriptionStatusSuccess", action.payload);
      state.loadingSubscription = false;
      state.subscription = action.payload;
    },
    fetchSubscriptionStatusFailure(state, action: PayloadAction<string>) {
      state.loadingSubscription = false;
      state.error = action.payload;
    },

    reactivateTickerRequest(state, action: PayloadAction<{ subId: number }>) {
      state.restartingSubs[String(action.payload.subId)] = true;
      state.error = null;
    },
    reactivateTickerSuccess(state, action: PayloadAction<{ subId: number }>) {
      delete state.restartingSubs[String(action.payload.subId)];
    },
    reactivateTickerFailure(state, action: PayloadAction<{ subId: number; error: string }>) {
      delete state.restartingSubs[String(action.payload.subId)];
      state.error = action.payload.error;
    },

    deleteTickerRequest(state, action: PayloadAction<{ subId: number }>) {
      state.removingSubs[String(action.payload.subId)] = true;
      state.error = null;
    },
    deleteTickerSuccess(state, action: PayloadAction<{ subId: number }>) {
      delete state.removingSubs[String(action.payload.subId)];
    },
    deleteTickerFailure(state, action: PayloadAction<{ subId: number; error: string }>) {
      delete state.removingSubs[String(action.payload.subId)];
      state.error = action.payload.error;
    },

    clearMyPageError(state) {
      state.error = null;
    },
  },
});

export const {
  fetchSubscriptionStatusRequest,
  fetchSubscriptionStatusSuccess,
  fetchSubscriptionStatusFailure,

  reactivateTickerRequest,
  reactivateTickerSuccess,
  reactivateTickerFailure,

  deleteTickerRequest,
  deleteTickerSuccess,
  deleteTickerFailure,

  clearMyPageError,
} = myPageSlice.actions;

export default myPageSlice.reducer;